import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiWhatsNewDataSeries = () => {
    const { allStrapiSerie } = useStaticQuery(graphql`
        query {
            allStrapiSerie(
                filter: {title: {regex: "/Collaborative Teams Toolkit for Trauma-Informed Care|ICWA Active Efforts Support Toolkit|Collaborating Across Service Systems: How to Develop a Comprehensive Data Approach for Families Affected by Prenatal Substance Exposure: A Two-Part Series|Harm Reduction in the Context of Child Well-Being|Child Welfare Supervisor’s Practice Guides to Safety and Risk|Cannabis Tip Sheets Series/"}}
              ) {
                nodes {
                  card_title
                  title
                  author
                  resource_date(formatString: "YYYY")
                  slug
                  thumbnail {
                    alternativeText
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                    }
                  }
                  body {
                    data {
                      childMarkdownRemark {
                        html
                        rawMarkdownBody
                        excerpt(format: PLAIN, pruneLength: 85)
                      }
                    }
                  }
                  resources {
                    title
                    slug
                  }
                  videos_webinars_series {
                      title
                      slug
                    }
                }
              }
          }
      `)
    return { allStrapiSerie }
}